import React, { useState, useRef } from "react";
import "./Schemes.css";
import BudgetList from "../../components/BudgetAllocation/Schemes/BudgetList";
import { useSelector } from "react-redux";
import SubHeader from '../../components/Subheader/Subheader';
import CreateButton from "../../components/Tools/CreateButton";
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';
import MainFilter from "../../components/Tools/MainFilter";
import DashboardFilter from "../Dashboard/components/DashboardFilter";

const Budgets = () => {
  const { financialYears, authData } = useSelector((state) => state.authData);
  const [key, setKey] = useState("list");
  const fyIdRef = useRef(localStorage.getItem('globalDateId'));
  const fyList = financialYears.payload.fy_list;

  const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
  }

  // filter setup or states (same pattern as Schemes.jsx)
  const [filterPayload, setFilterPayload] = useState({
    searchStr: "",
    fromDate: "",
    toDate: "",
    dateColumn: "",
    department_id: "",
    tier: "",
    consolidate: false,
  });

  const [filterApplied, setFilterApplied] = useState({
    searchStr: "",
    fromDate: "",
    toDate: "",
    dateColumn: "",
    department_id: "",
    tier: "",
    consolidate: false,
    refresh: false,
  });

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleInput = async (e) => {
    const { name, value } = e.target;
    setFilterPayload((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const bootList = async () => {
    setFilterApplied(filterPayload);
    setOpen(false);
  };

  const handleFilterRemove = async (name) => {
    const newPayload = {
      ...filterPayload,
      [name]: "",
    };
    setFilterPayload(newPayload);
    setFilterApplied(newPayload);
  };

  return (
    <>
      <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
      <div className="scheme">
        <div className="row" style={{ padding: "10px 16px" }}>
            <div className="col-md-6">
                <h4 style={{ color: "#28326f", margin:0}}>Budgets</h4>
                <CustomBreadcrumbs linksArray={[]} title="Budgets"/>
            </div>
            <div className="col-md-6"></div>
        </div>

        <div className="scheme p-3">
          <div className="scheme p-2">
            <DashboardFilter
              openFilterModal={setOpen}
              filterPayload={filterApplied}
              handleFilterRemove={handleFilterRemove}
              isTierRemovalRequired={true}
            />

            <BudgetList
              fromDate={filterApplied.fromDate}
              toDate={filterApplied.toDate}
              fyId={fyIdRef.current}
              searchStr={filterApplied.searchStr}
              tier={filterApplied.tier}
              departmentId={filterApplied.department_id}
              fy_list={fyList}
            />
          </div>
        </div>

        {
          (authData.user.user_type === 'l1' && authData.user.department_details.department_level === 'T1') && <CreateButton title={"Add Budget"} url={"/add-budget"}/>
        }

        <MainFilter
          open={open}
          handleClose={handleClose}
          handleInput={handleInput}
          handleOpen={handleOpen}
          handleFilterClick={bootList}
          filterPayload={filterPayload}
          setConsolidate={setFilterPayload}
          type="Budgets"
        />
      </div>
    </>
  );
};

export default Budgets;
